import type { ReactNode } from 'react';

export const symbol_moon_stars: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M483-80q-84 0-157.5-32t-128-86.5Q143-253 111-326.5T79-484q0-128.94 74.5-233.97T351-865q11-4 21.5-2t18.28 7.87Q397-854 400.5-844q3.5 10 2.5 24-3 85 27 161.5T520-522q60 60 137 90.5T819-404q14-1 23.48 2.27 9.49 3.26 15.52 10.73 6 8 8 18t-2 21q-42 122-146.5 197T483-80Zm0-60q100 0 182-57t132-145q-90-8-173-41.5T477.5-480Q414-543 381-625.5T340-797q-88 48-144.5 130.5T139-484q0 143.33 100.33 243.67Q339.67-140 483-140Zm-6-340Zm116-209-63-64q-9-9-9-21t9-21l63-64q9-9 21-9t21 9l64 64q9 9 9 21t-9 21l-64 64q-9 9-21 9t-21-9Zm200 120-24-24q-9-9-9-21t9-21l24-24q9-9 21-9t21 9l24 24q9 9 9 21t-9 21l-24 24q-9 9-21 9t-21-9Z"
		/>
	</svg>
);
